/** Legacy localStorage key for last-used workspace (unscoped). */
export const LEGACY_WORKSPACE_STORAGE_KEY = 'currentWorkspaceId';

/**
 * localStorage key for last-used workspace.
 * When organizationId is set, scopes by org so switching orgs does not restore another org's workspace.
 */
export function getCurrentWorkspaceStorageKey(userId, organizationId = null) {
  if (!userId) return LEGACY_WORKSPACE_STORAGE_KEY;
  if (organizationId != null && String(organizationId).trim() !== '') {
    return `currentWorkspaceId_${userId}_${organizationId}`;
  }
  return `currentWorkspaceId_${userId}`;
}

/**
 * Read saved workspace ID from localStorage.
 * Per-org keys are preferred when organizationId is set; falls back to user-only key then legacy global.
 */
export function getSavedWorkspaceId(userId, organizationId = null) {
  if (typeof window === 'undefined') return null;
  const legacy = localStorage.getItem(LEGACY_WORKSPACE_STORAGE_KEY);

  if (userId) {
    const userOnlyKey = getCurrentWorkspaceStorageKey(userId, null);

    if (organizationId != null && String(organizationId).trim() !== '') {
      const orgSaved = localStorage.getItem(getCurrentWorkspaceStorageKey(userId, organizationId));
      if (orgSaved) return orgSaved;
    }

    const userOnlySaved = localStorage.getItem(userOnlyKey);
    if (userOnlySaved) return userOnlySaved;

    if (legacy) {
      localStorage.setItem(userOnlyKey, legacy);
      localStorage.removeItem(LEGACY_WORKSPACE_STORAGE_KEY);
      return legacy;
    }
    return null;
  }
  return legacy || null;
}

/**
 * Remove saved workspace: a specific org key when organizationId is set; otherwise legacy, user-only, and all org-scoped keys for the user.
 */
export function clearSavedWorkspaceId(userId, organizationId = null) {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(LEGACY_WORKSPACE_STORAGE_KEY);
  if (!userId) return;

  if (organizationId != null && String(organizationId).trim() !== '') {
    localStorage.removeItem(getCurrentWorkspaceStorageKey(userId, organizationId));
    return;
  }

  localStorage.removeItem(getCurrentWorkspaceStorageKey(userId, null));
  const prefix = `currentWorkspaceId_${userId}_`;
  try {
    const toRemove = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const k = localStorage.key(i);
      if (k && k.startsWith(prefix)) toRemove.push(k);
    }
    toRemove.forEach((k) => localStorage.removeItem(k));
  } catch {
    // ignore quota / access errors
  }
}
